export interface MaintenanceConfig {
  readonly message: string;
  readonly start: number;
  readonly end: number;
  readonly resumeUrl?: string;
  readonly homeUrl?: string;
}

export const RECEIPTS_MAINTENANCE: MaintenanceConfig = {
  message: 'Este extrato est\u00e1 temporariamente indispon\u00edvel para manuten\u00e7\u00e3o do sistema.',
  start: Date.parse('2026-10-08T20:00:00-03:00'),
  end: Date.parse('2026-10-13T07:00:00-03:00'),
};

export const SERVICE_NOW_MAINTENANCE: MaintenanceConfig = {
  message: 'O CES (ServiceNow) est\u00e1 temporariamente indispon\u00edvel para manuten\u00e7\u00e3o do sistema.',
  start: Date.parse('2026-10-16T18:00:00-03:00'),
  end: Date.parse('2026-10-19T00:00:00-03:00'),
  resumeUrl: '/panel/network/home',
};

export const RETIREE_MAINTENANCE: MaintenanceConfig = {
  message: 'Este servi\u00e7o est\u00e1 temporariamente indispon\u00edvel para manuten\u00e7\u00e3o do sistema.',
  start: RECEIPTS_MAINTENANCE.start,
  end: RECEIPTS_MAINTENANCE.end,
  homeUrl: '/retiree/home',
};

export function isMaintenanceActive(config: MaintenanceConfig): boolean {
  const now = Date.now();
  return now >= config.start && now < config.end;
}
